export class Patient {
  constructor(
    public firstName: string,
    public lastName: string,
    public cnp: string,
    public dateOfLastExamination: string,
    public dateOfNextExamination: string,
    public job: string,
    public aptitudeFileUrl: string,
    public fullName?: string
  ) {}
}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/models/patient.ts